module.exports = __webpack_public_path__ + "img/member.d37c06dc.svg";